export default __webpack_public_path__ + "static/media/mahindra.f3ca7360.webp";